import {
  ShaderStore,
  init_shaderStore
} from "./chunk-74QERPGX.mjs";
import {
  __esm
} from "./chunk-AU4RG7EN.mjs";

// node_modules/@babylonjs/core/ShadersWGSL/ShadersInclude/meshUboDeclaration.js
var name, shader;
var init_meshUboDeclaration = __esm({
  "node_modules/@babylonjs/core/ShadersWGSL/ShadersInclude/meshUboDeclaration.js"() {
    "use strict";
    init_shaderStore();
    name = "meshUboDeclaration";
    shader = `struct Mesh {world : mat4x4<f32>,
visibility : f32,};var<uniform> mesh : Mesh;
#define WORLD_UBO
`;
    ShaderStore.IncludesShadersStoreWGSL[name] = shader;
  }
});

export {
  init_meshUboDeclaration
};
